import { apiClientAudio } from '@/plugins/axios'

export default {
  getAudios() {
    return apiClientAudio().get('/audio')
  },
  getAudio(id) {
    return apiClientAudio().get(`/audio/${id}`)
  },
  getAudioUse(id) {
    return apiClientAudio().get(`/audio/use/${id}`)
  },
  postAudio(audio) {
    let formData = new FormData()
    formData.append('description', audio.description)
    formData.append('audio', audio.files)

    return apiClientAudio().post('/audio', formData)
  },

  deleteAudio(id) {
    return apiClientAudio().delete(`/audio/${id}`)
  },
}
